/**
 * @generated SignedSource<<24cd862f082e03a76834e8a93337a06d>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { DateTime } from "@/common/relayCustomScalar";
import { FragmentRefs } from "relay-runtime";
export type EventJoinButtonFragment$data = {
  readonly entityRuleAgreements: {
    readonly nodes: ReadonlyArray<{
      readonly id: string;
    }>;
  };
  readonly forum: {
    readonly entitySubscription: {
      readonly id: string;
    } | null | undefined;
    readonly id: string;
  };
  readonly id: string;
  readonly latestRule: {
    readonly entityAgreement: {
      readonly createdAt: DateTime;
      readonly id: string;
    } | null | undefined;
    readonly id: string;
    readonly text: string;
  };
  readonly membership: {
    readonly id: string;
  } | null | undefined;
  readonly viewerCanAgree: boolean;
  readonly viewerCanJoin: boolean;
  readonly " $fragmentType": "EventJoinButtonFragment";
};
export type EventJoinButtonFragment$key = {
  readonly " $data"?: EventJoinButtonFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventJoinButtonFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  (v0/*:: as any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventJoinButtonFragment",
  "selections": [
    (v0/*:: as any*/),
    {
      "alias": "viewerCanAgree",
      "args": [
        {
          "kind": "Literal",
          "name": "action",
          "value": "CREATE_EVENT_RULE_AGREEMENT"
        }
      ],
      "kind": "ScalarField",
      "name": "viewerCan",
      "storageKey": "viewerCan(action:\"CREATE_EVENT_RULE_AGREEMENT\")"
    },
    {
      "alias": "viewerCanJoin",
      "args": [
        {
          "kind": "Literal",
          "name": "action",
          "value": "JOIN_EVENT"
        }
      ],
      "kind": "ScalarField",
      "name": "viewerCan",
      "storageKey": "viewerCan(action:\"JOIN_EVENT\")"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EventMembership",
      "kind": "LinkedField",
      "name": "membership",
      "plural": false,
      "selections": (v1/*:: as any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 1
        }
      ],
      "concreteType": "EventRuleAgreementConnection",
      "kind": "LinkedField",
      "name": "entityRuleAgreements",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EventRuleAgreement",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": (v1/*:: as any*/),
          "storageKey": null
        }
      ],
      "storageKey": "entityRuleAgreements(first:1)"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Forum",
      "kind": "LinkedField",
      "name": "forum",
      "plural": false,
      "selections": [
        (v0/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "entitySubscription",
          "plural": false,
          "selections": (v1/*:: as any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EventRule",
      "kind": "LinkedField",
      "name": "latestRule",
      "plural": false,
      "selections": [
        (v0/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "text",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "EventRuleAgreement",
          "kind": "LinkedField",
          "name": "entityAgreement",
          "plural": false,
          "selections": [
            (v0/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdAt",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Event",
  "abstractKey": null
};
})();

(node as any).hash = "2074edfa1202579ff29a2eeb7ab2f898";

export default node;
